// extracted by mini-css-extract-plugin
export default {"tbody":"TbodyError_tbody__7W-m3"};